import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "8898798857";
const PHONE_NUMBER = "+918898798857";

export default function ContactPage() {
  const handleWhatsApp = (message) => {
    const text = encodeURIComponent(message || "Hi, I'd like to book an appointment at Bunty Hair Master.");
    window.open(`https://wa.me/91${WHATSAPP_NUMBER}?text=${text}`, "_blank");
  };

  return (
    <div className="min-h-screen pt-20" data-testid="contact-page">
      {/* Hero Section */}
      <section className="section-spacing bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto container-padding">
          <div className="max-w-3xl">
            <p className="font-['Cormorant_Garamond'] text-[#D4AF37] text-sm tracking-[0.3em] uppercase mb-4">
              Get In Touch
            </p>
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl text-white font-semibold leading-tight mb-6">
              Contact Us
            </h1>
            <p className="text-white/70 text-lg">
              Have questions? We'd love to hear from you. Reach out via WhatsApp for the quickest response or visit us at our salon.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-spacing bg-[#121212]">
        <div className="max-w-7xl mx-auto container-padding">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
            {/* WhatsApp CTA Section */}
            <div className="bg-[#0A0A0A] border border-white/5 p-8 md:p-10 flex flex-col">
              <h2 className="font-['Playfair_Display'] text-2xl text-white mb-4">
                Message Us on WhatsApp
              </h2>
              <p className="text-white/60 mb-8">
                Tap below to start a conversation. We typically respond within minutes during business hours.
              </p>

              <div className="space-y-4 flex-1">
                {/* Main WhatsApp CTA */}
                <button
                  onClick={() => handleWhatsApp("Hi, I'd like to book an appointment at Bunty Hair Master.")}
                  className="w-full bg-[#25D366] p-6 flex items-center gap-4 hover:bg-[#1fb855] transition-colors"
                  data-testid="contact-whatsapp-btn"
                >
                  <div className="w-14 h-14 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-7 h-7 text-white" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </div>
                  <div className="text-left">
                    <p className="text-white font-medium text-lg">Book an Appointment</p>
                    <p className="text-white/70 text-sm">Quick response guaranteed</p>
                  </div>
                </button>

                {/* Quick message options */}
                <button
                  onClick={() => handleWhatsApp("Hi, I'd like to know about your services and pricing.")}
                  className="w-full bg-[#1A1A1A] border border-white/10 p-5 flex items-center gap-4 hover:border-[#D4AF37]/30 transition-colors text-left"
                >
                  <div className="w-10 h-10 bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center flex-shrink-0">
                    <MessageCircle className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <p className="text-white font-medium">Ask About Services & Pricing</p>
                    <p className="text-white/50 text-sm">Get details on any service</p>
                  </div>
                </button>

                <button
                  onClick={() => handleWhatsApp("Hi, I have a general enquiry about Bunty Hair Master.")}
                  className="w-full bg-[#1A1A1A] border border-white/10 p-5 flex items-center gap-4 hover:border-[#D4AF37]/30 transition-colors text-left"
                >
                  <div className="w-10 h-10 bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center flex-shrink-0">
                    <MessageCircle className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <p className="text-white font-medium">General Enquiry</p>
                    <p className="text-white/50 text-sm">Any other questions</p>
                  </div>
                </button>
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h2 className="font-['Playfair_Display'] text-2xl text-white mb-8">
                Contact Information
              </h2>

              <div className="space-y-6 mb-10">
                <div className="contact-info-item">
                  <div className="contact-icon">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Location</h4>
                    <p className="text-white/60 text-sm">
                      Shop No. 3, Vikas Palms Society,<br />
                      Dr. Ambedkar Road, Uthalsar,<br />
                      Thane West – 400606<br />
                      (Backside Vikas Palms)
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <Phone className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Phone</h4>
                    <a 
                      href="tel:+918898798857"
                      className="text-[#D4AF37] hover:text-[#F3E5AB] transition-colors"
                      data-testid="contact-phone-link"
                    >
                      +91 88987 98857
                    </a>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <Mail className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Email</h4>
                    <p className="text-white/60 text-sm">contact@buntyhairmaster.com</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <Clock className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Hours</h4>
                    <p className="text-white/60 text-sm">
                      Open Daily: 9:30 AM - 10:00 PM
                    </p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.5!2d72.9791!3d19.2094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b8fcdc6fbbcb%3A0x4ae9d7ec18a7e2e9!2sVikas%20Palms%2C%20Thane%20West%2C%20Thane%2C%20Maharashtra%20400606!5e0!3m2!1sen!2sin!4v1234567890"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Bunty Hair Master Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
